module.exports = __webpack_public_path__ + "img/machine-1.dd1c1cb6.png";